import moment from 'moment-timezone';

export default {
    twitterSelected: (state) => state.formData.social_networks.find((item) => item.network_id == 2),

    linkedInSelected: (state) => state.formData.social_networks.find((item) => item.network_id == 3),

    websiteLength: (state, getters) => {
        if (state.formData.website) {
            return getters.twitterSelected ? state.twitter_url_length : state.formData.website.length + 2;
        }

        return 0;
    },

    post_message_length: (state, getters) => {
        if (getters.twitterSelected) {
            return 280 - getters.websiteLength;
        } if (getters.linkedInSelected) {
            return 3000;
        }
        return 5000 - getters.websiteLength;
    },

    postFormattedFormData: (state) => ({ ...state.formData,
        post_date: state.formData.post_date ? moment(state.formData.post_date, 'MM/DD/YYYY').format('YYYY-MM-DD HH:mm:ss') : null,
        remove_date: state.formData.remove_date ? moment(state.formData.remove_date, 'MM/DD/YYYY').format('YYYY-MM-DD HH:mm:ss') : null }),
};
